<template>
  <div :id="modalId">
    <img
      @click="setPhotoView(images[0].image, 0)"
      v-if="images"
      class="principal-image"
      :src="images[0].image"
    />
    <ion-row v-if="images" class="ion-justify-content-start small-images-content h-fit-content">
      <template v-for="(image, idx) in images.slice(1)" :key="'small-image-' + idx">
        <ion-col
          @click="setPhotoView(image.image, idx + 1)"
          v-if="(images.length <= 5 && idx <= 5) || (images.length > 5 && idx < 4)"
          :class="
            idx === 0 || idx === 3 ? 'ion-no-padding h-fit-content' : 'no-padding-y h-fit-content'
          "
          size="3"
          ><img class="secondary-image" :src="image.image" />
          <div v-if="idx === 3 && images.length > 5" class="overlay-blue"></div>
          <div
            v-if="idx === 3 && images.length > 5"
            class="overlay-text"
            @click="setPhotoView(image.image, idx + 1)"
          >
            +{{ images.length - 4 }}
          </div>
        </ion-col>
      </template>
    </ion-row>
  </div>
  <div>
    <ion-modal ref="modalPhotos" :trigger="modalId">
      <ion-header class="bg-dark no-shadow justify-space-end d-flex w-100">
        <ion-button color="white" fill="clear" :strong="true" @click="cancel()"
          ><ion-icon color="white" :icon="closeOutline"
        /></ion-button>
      </ion-header>
      <ion-content>
        <swiper @swiper="onSwiper" class="swiper bg-dark">
          <swiper-slide
            class="w-100"
            v-for="(image, idx) in images"
            :key="`image-${modalId}-${idx}`"
          >
            <img class="carousel-img" :src="image.image" />
            <div class="swiper-image-controls">
              <div>
                <ion-button
                  v-if="currentImg > 0"
                  size="large"
                  color="light"
                  fill="clear"
                  class="swiper-buttons"
                  @click="handleSlideTo(currentImg - 1)"
                >
                  <ion-icon :icon="chevronBackOutline"></ion-icon>
                </ion-button>
              </div>
              <div>
                <ion-button
                  v-if="currentImg < totalImages! - 1"
                  size="large"
                  color="light"
                  fill="clear"
                  class="swiper-buttons"
                  @click="handleSlideTo(currentImg + 1)"
                >
                  <ion-icon :icon="chevronForwardOutline"></ion-icon>
                </ion-button>
              </div>
            </div>
          </swiper-slide> </swiper
      ></ion-content>
    </ion-modal>
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { IonRow, IonCol, IonContent, IonModal, IonHeader, IonButton, IonIcon } from '@ionic/vue';
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { chevronBackOutline, chevronForwardOutline } from 'ionicons/icons';
  import 'swiper/css';
  import '@ionic/vue/css/ionic-swiper.css';
  import { Photos } from '@/interfaces/elastic/elastic.interface';
  import { generateUniqueId } from '@/utils/global-utils';
  import { closeOutline } from 'ionicons/icons';

  const props = withDefaults(
    defineProps<{
      images?: Photos[];
      typeViewer: string;
    }>(),
    {
      typeViewer: 'rental-unit',
    },
  );

  const modalPhotos = ref();
  const cancel = () => modalPhotos.value.$el.dismiss(null, 'cancel');
  const swiperInstance = ref();
  const selectedSwiper = ref(0);
  const currentImg = ref(0);
  const totalImages = props.images?.length;
  const uniqueId = generateUniqueId(props.typeViewer);
  const modalId = computed(() => `modalPhotos-${uniqueId}`);

  const setPhotoView = (url: string, idx: number) => {
    handleSlideTo(idx);
  };

  const handleSlideTo = (idx: number) => {
    if (idx >= 0 && idx <= totalImages! - 1) {
      selectedSwiper.value = idx;
      swiperInstance.value?.slideTo(selectedSwiper.value);
      currentImg.value = idx;
    }
  };

  const onSwiper = (swiper: any) => {
    swiperInstance.value = swiper;
    swiperInstance.value?.slideTo(selectedSwiper.value);
  };
</script>

<style lang="css" scoped>
  .carousel-img {
    width: 100%;
  }
  .small-images-content {
    align-items: initial;
    overflow: hidden;
  }

  .secondary-image {
    height: 85px;
    width: 100%;
    object-fit: cover;
    cursor: pointer;
  }

  .no-padding-y {
    padding: 0px 5px !important;
  }

  .swiper {
    height: 100% !important;
  }

  .overlay-blue {
    position: absolute;
    width: 100%;
    height: 85px;
    top: 0;
    background-color: #1a476f;
    opacity: 0.5;
    cursor: pointer;
  }
  .overlay-text {
    position: absolute;
    width: 100%;
    height: 85px;
    top: 0;
    cursor: pointer;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
  }

  .swiper-image-controls {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    display: flex;
    justify-content: space-between;
    padding: 0 0rem; /* Ajusta el espacio entre los botones y los bordes */
  }

  /* .swiper-buttons {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
  } */
</style>
